import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NxHeroBasicComponent } from './nx-hero-basic.component';
import { FlexLayoutModule } from '@angular/flex-layout';



@NgModule({
  declarations: [
    NxHeroBasicComponent
  ],
  imports: [
    CommonModule,
    FlexLayoutModule
  ],
  exports: [
    NxHeroBasicComponent
  ]
})
export class NxHeroBasicModule { }
